"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsSelector = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _Autocomplete = _interopRequireDefault(require("@civicplus/preamble/lib/Autocomplete/Autocomplete"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var TagsSelector = function TagsSelector(props) {
  var _useState = (0, _react.useState)(props.value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    className: (0, _classnames["default"])("prmbl-tagsSelector", props.className),
    disabled: props.disabled,
    helperText: props.helperText,
    label: props.label,
    multiSelect: true,
    onChange: function onChange(selected) {
      var _selected;

      selected = (_selected = selected) !== null && _selected !== void 0 ? _selected : [];
      var mapped = selected.map(function (w) {
        return w.value;
      });
      setValue(mapped);
      props.onChange(mapped);
    },
    allowOptionCreation: true,
    value: value.map(function (s) {
      return {
        label: s,
        value: s
      };
    })
  });
};

exports.TagsSelector = TagsSelector;